package org.hs_soft.runmynesto.data.api_datasource.authentication

import androidx.compose.runtime.NoLiveLiterals
import org.hs_soft.runmynesto.domain.repository.network_datasource.login.SendCodeForResetPassRepository
import org.hs_soft.runmynesto.domain.util.jsObject
import org.hs_soft.runmynesto.modules.Auth

class SendCodeForResetPassRepositoryImpl:SendCodeForResetPassRepository
{
    @NoLiveLiterals
    override suspend fun sendResetCodeToEmail(
        email:String,
        onSuccess: () -> Unit,
        onError:(String)->Unit,
    ) {
        val options = jsObject<Any> {
            this["username"] = email
        }

        Auth.resetPassword(options).then { result ->
            console.log(result)
            onSuccess()

        }.catch { error: dynamic ->
            onError(error.toString())
            console.log(error.toString())
        }
    }


}